import { render, staticRenderFns } from "./PdfSplit.vue?vue&type=template&id=4373ba83&scoped=true"
import script from "./PdfSplit.vue?vue&type=script&lang=js"
export * from "./PdfSplit.vue?vue&type=script&lang=js"
import style0 from "./PdfSplit.vue?vue&type=style&index=0&id=4373ba83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4373ba83",
  null
  
)

export default component.exports